module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vnerv10-131730eb1f39ed5f1c11efb962c7ea61.jpg";